import { Skeleton } from '@/components/atoms';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface PropertyCardSkeletonProps {
    layout?: 'grid' | 'list';
}

/**
 * Skeleton component for PropertyCard
 * Matches the structure and dimensions of PropertyCard
 */
export function PropertyCardSkeleton({ layout = 'grid' }: PropertyCardSkeletonProps) {
    const colors = useUIColors();

    if (layout === 'list') {
        return (
            <View style={[styles.listContainer, { backgroundColor: colors.backgroundLevel1, borderColor: colors.backgroundLevel2 }]}>
                <View style={styles.listRow}>
                    {/* Image skeleton */}
                    <Skeleton width={107} height={107} borderRadius={12} />
                    
                    {/* Content skeleton */}
                    <View style={styles.listContent}>
                        <Skeleton width={120} height={14} />
                        <Skeleton width={180} height={16} style={{ marginTop: 4 }} />
                        
                        <View style={styles.listMetaRow}>
                            <View style={styles.listMetaItem}>
                                <Skeleton width={60} height={14} />
                                <Skeleton width={40} height={12} style={{ marginTop: 4 }} />
                            </View>
                            <View style={styles.listMetaItem}>
                                <Skeleton width={60} height={14} />
                                <Skeleton width={40} height={12} style={{ marginTop: 4 }} />
                            </View>
                        </View>
                        
                        <Skeleton width={140} height={24} borderRadius={8} style={{ marginTop: 8 }} />
                    </View>
                </View>
            </View>
        );
    }

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundLevel1, borderColor: colors.backgroundLevel2 }]}>
            {/* Image skeleton */}
            <Skeleton width="100%" height={200} borderRadius={8} />
            
            {/* Content skeleton */}
            <View style={styles.content}>
                <View style={styles.titleSection}>
                    <Skeleton width={120} height={12} />
                    <Skeleton width={180} height={16} style={{ marginTop: 4 }} />
                </View>
                
                <View style={styles.metaRow}>
                    <View style={styles.metaItem}>
                        <Skeleton width={60} height={14} />
                        <Skeleton width={40} height={12} style={{ marginTop: 4 }} />
                    </View>
                    <View style={styles.metaItem}>
                        <Skeleton width={60} height={14} />
                        <Skeleton width={40} height={12} style={{ marginTop: 4 }} />
                    </View>
                </View>
                
                <Skeleton width={140} height={24} borderRadius={8} />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        borderRadius: 12,
        overflow: 'hidden',
        padding: 8,
        gap: 8,
        borderWidth: 1,
    },
    listContainer: {
        borderRadius: 12,
        overflow: 'hidden',
        padding: 12,
        gap: 16,
        borderWidth: 1,
    },
    listRow: {
        flexDirection: 'row',
        gap: 12,
    },
    listContent: {
        flex: 1,
        gap: 8,
    },
    content: {
        gap: 16,
    },
    titleSection: {
        gap: 4,
    },
    metaRow: {
        flexDirection: 'row',
        gap: 16,
    },
    listMetaRow: {
        flexDirection: 'row',
        gap: 16,
        marginTop: 8,
    },
    metaItem: {
        flex: 1,
        gap: 4,
    },
    listMetaItem: {
        flex: 1,
        gap: 4,
    },
});

export default PropertyCardSkeleton;

